/**
 * 用户选择模块
 */
import React, { useMemo, memo } from 'react';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import cls from 'classnames';
import intl from 'react-intl-universal';

import { MemberType } from '@/config/constant';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { handleRentItemGuestChange } from '@/redux/actions/reservation/checkInByReserve';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkInByReserve';

import { getPopupContainer } from '../../helper';
import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { allGuestList, rentRoomInfos, commonInfo } = state;
  return { allGuestList, rentRoomInfos, isAppendMode: commonInfo.isAppendMode };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  callGuestChange: handleRentItemGuestChange,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;
interface IProps {
  recordId: string;
}

const { Option } = Select;

const Index: React.FC<IProps & MapStateProps & MapDispatchProps> = (props) => {
  const { recordId, callGuestChange, allGuestList, rentRoomInfos, isAppendMode } = props;

  const selectInfo = useMemo(() => {
    const selectOptions = []; // 选项
    let itemGuestList: string[] = []; // 当前房间宾客id
    const allValueMap = {}; // 所有房间宾客map
    const recordValueMap = {}; // 当前房间宾客map
    // 遍历所有房间选中的宾客
    rentRoomInfos.forEach((item) => {
      const guestList = item.guestList || [];
      if (item.indexId === recordId) {
        // 当前房间宾客
        itemGuestList = guestList;
      }
      guestList.forEach((guestId) => {
        allValueMap[guestId] = true;
      });
    });
    // 当前房间宾客map
    itemGuestList.forEach((guestId) => {
      recordValueMap[guestId] = true; // 记录到当前房间下
      delete allValueMap[guestId]; // 从全部房间剔除
    });
    (allGuestList || []).forEach((item) => {
      const { name, indexId, memberType } = item;
      if (!name || (isAppendMode && memberType === MemberType.HouseOwner)) return; // 没有名字 或追加模式下的房主
      const isCurrentChecked = !!recordValueMap[indexId]; // 当前房间选中
      const isOtherChecked = !!allValueMap[indexId]; // 其它房间选中
      selectOptions.push(
        <Option value={indexId} label={name} key={indexId}>
          <div className={styles.optionItem}>
            <div className={styles.optionLabel}>{name}</div>
            <div
              className={cls({
                [styles.optionCurrentChecked]: isCurrentChecked,
                [styles.optionOtherChecked]: isOtherChecked,
              })}
            >
              {isCurrentChecked || isOtherChecked ? <CheckOutlined /> : null}
            </div>
          </div>
        </Option>,
      );
    });
    return {
      itemGuestList,
      selectOptions,
    };
  }, [allGuestList, rentRoomInfos, isAppendMode]);

  const handleSelectChange: (val: string[]) => void = (val) => {
    callGuestChange(recordId, val || []);
  };

  return (
    <Select
      mode="multiple"
      placeholder={intl.get('drawer_checkin_room_guest_picker_placeholder')}
      notFoundContent={intl.get('drawer_checkin_room_guest_picker_null_content')}
      showArrow
      showSearch={false}
      filterOption={false}
      className={styles.guestSelector}
      popupClassName={styles.guestDropdownWrapper}
      value={selectInfo.itemGuestList}
      getPopupContainer={getPopupContainer}
      onChange={handleSelectChange}
    >
      {selectInfo.selectOptions}
    </Select>
  );
};

export default connect<MapStateProps, MapDispatchProps, IProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
